import React, { useState } from 'react'
import { Box, Menu, MenuItem } from '@mui/material'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown } from '@fortawesome/pro-duotone-svg-icons/faCaretDown'

import Avatar from './Avatar.tsx'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'

const AvatarGroup = ({ users, kedo, props }) => {
    const [itemsToShow, setItemsToShow] = useState(1)

    const [anchorEl, setAnchorEl] = useState(null)

    const openMenu = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const closeMenu = () => {
        setAnchorEl(null)
    }

    const userFilter =
        users && users.filter
            ? users
                  .filter((user) => user.userId !== kedo.user().getUserId())
                  .sort((a, b) =>
                      a.username > b.username
                          ? 1
                          : b.username > a.username
                          ? -1
                          : 0
                  )
            : []
    const me =
        users && users.find
            ? users.find((user) => user.userId === kedo.user().getUserId())
            : null

    if (me) {
        userFilter.push(me)
    }

    const buttons = () => {
        if (users && users.length > itemsToShow) {
            return (
                <Box
                    sx={{ display: 'inline-flex', ml: 1 }}
                    className="avatar-online"
                >
                    <StyledButton
                        variant="contained"
                        size="small"
                        onClick={openMenu}
                        endIcon={
                            <FontAwesomeIcon icon={faCaretDown} size="sm" />
                        }
                        sx={{
                            '& .MuiButton-endIcon svg ': {
                                fontSize: '16px',
                            },
                        }}
                    >
                        +{users.length - itemsToShow}
                    </StyledButton>
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={closeMenu}
                    >
                        {userFilter.slice(itemsToShow).map((user, i) => (
                            <MenuItem
                                key={i}
                                onClick={() => {
                                    history.push('/user/' + user.userId)
                                    closeMenu()
                                }}
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                    }}
                                >
                                    <Avatar
                                        kedo={kedo}
                                        user={user}
                                        key={i}
                                        props={props}
                                        options={{
                                            size: 33,
                                            showPresence: true,
                                        }}
                                    />
                                    &nbsp;
                                    {user.username}
                                </Box>
                            </MenuItem>
                        ))}
                    </Menu>
                </Box>
            )
        }
    }

    return (
        <div className="container">
            {userFilter.slice(0, itemsToShow).map((user, i) => (
                <Avatar
                    onClick={() =>
                        this.props.history.push('/user/' + user.userId)
                    }
                    kedo={kedo}
                    user={user}
                    key={i}
                    props={props}
                    options={{
                        size: 35,
                        showPresence: true,
                    }}
                />
            ))}

            {buttons()}
        </div>
    )
}

export default AvatarGroup
